import Repository from '@/repositories/marketing'
const resource = '/lists'

export default {
    getList (config) {
        return Repository.get(`${resource}.json`, config)
    },
    bulkRefresh(config){
        return Repository.post(`${resource}/bulk_refresh.json`, config)
    },
    refresh (id) {
        return Repository.get(`${resource}/${id}/refresh_contacts_count.json`)
    },
    delete (id) {
        return Repository.delete(`${resource}/${id}.json`)
    },
    bulkDelete(config){
        return Repository.delete(`${resource}/bulk_delete.json`, config)
    },
    duplicate (id) {
        return Repository.get(`${resource}/${id}/duplicate.json`)
    },
    getFieldsListData (id){
        return Repository.get(`${resource}/${id}/fields_list_data.json`)
    },
    getAutomatedFtpImports (id){
        return Repository.get(`${resource}/${id}/automated_ftp_imports.json`)
    },
    getCartsList (id){
        return Repository.get(`${resource}/${id}/list_carts.json`)
    },
    getCarts (config){
        return Repository.get(`/carts.json`,config)
    },
    updateCarts (listId, data) {
        return Repository.put(`${resource}/${listId}/cart_update.json`, data)
    },
    updateListDetails (listId, data) {
        return Repository.put(`${resource}/${listId}/set_list_fields.json`, data)
    },
    getExportOption(config){
        return Repository.get(`${resource}/export_options.json`,config)
    },
    exportContact(listId,payload,config){
        return Repository.post(`${resource}/${listId}/export.json`, payload, config)
    },
    changeListType(listId,config){
        return Repository.get(`${resource}/${listId}/list_status_update.json`,config)
    },
    getListStats (listId) {
        return Repository.get(`${resource}/${listId}.json`)
    },
    getTimelineStats (id, type, config) {
        return Repository.get(`${resource}/${id}/${type}.json`, config)
    },
    getRecentActivities (id, config) {
        return Repository.get(`${resource}/${id}/recent_activities.json`, config)
    },
    filters (listId,config){
        return Repository.get(`${resource}/${listId}/filters.json`,config)
    },
    getFTPImportsData(listId,idFTP){
        return Repository.get(`${resource}/${listId}/imports/${idFTP}.json`)
    },
    importList(listId, config){
        return Repository.post(`${resource}/${listId}/import.json`, config)
    },
    updateFTPImports(listId, config,importId){
        return Repository.put(`${resource}/${listId}/imports/${importId}.json`, config)
    },
    addFTPImports(listId, config){
        return Repository.post(`${resource}/${listId}/imports.json`, config)
    },
    deleteFTPImport(listId, importId){
        return Repository.delete(`${resource}/${listId}/imports/${importId}.json`)
    },
    getBrands(config){
        return Repository.get(`/brands.json`,config)
    },
    createList(payload, config){
        return Repository.post(`/lists.json`, payload, config)
    },
    getListById(listId, config){
        return Repository.get(`${resource}/${listId}/edit.json`, config)
    },
    editList(listId, payload, config) {
        return Repository.put(`/lists/${listId}.json`, payload, config)
    },
    getDuplicateList(listId, config) {
        return Repository.get(`${resource}/${listId}/duplicate.json`, config)
    },
    getFileOptions(config){
        return Repository.get(`/ftp_import_file_options.json`, config)
    },
    importViaFtp(list_id,payload,config){
        return Repository.put(`${resource}/${list_id}/ftp_import.json`, payload, config)
    },
    importList(list_id, payload, config){
        return Repository.post(`${resource}/${list_id}/import.json`, payload, config)
    },
    importListViaPost(list_id, payload, config){
        return Repository.post(`${resource}/${list_id}/import.json`, payload, config)
    },
    showAutomatedImport(list_id,import_id,config){
        return Repository.get(`/lists/${list_id}/imports/${import_id}.json`, config)
    },
    getUserInfo(config){
        return Repository.get(`/lists/new.json`, config)
    },
    importStatus(list_id){
        return Repository.get(`${resource}/${list_id}/import_status.json`)
    },
    archiveRecord(id,config){
        return Repository.post(`${resource}/${id}/archive_record.json`, config)
    },
    checkRecordInUse(id,config){
        return Repository.get(`${resource}/${id}/check_modules_in_use.json`, config)
    },
    getCampaignLists(listId,config){
        return Repository.get(`${resource}/${listId}/sms_campaign_lists.json`,config)
    },
    fetchSMSCampaignVolume(listId, payload) {
        return Repository.get(`${resource}/${listId}/sms_campaign_volume.json`, payload)
    },
}
